if (!customElements.get('country-selector')) {
  customElements.define(
    'country-selector',
    class CountrySelector extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          select: this.querySelector('[js-country-selector="select"]'),
          flag: this.querySelector('[js-country-selector="flag"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        if (this.nodeSelectors.select) {
          this.nodeSelectors.select.addEventListener('change', this.handleSelectChange.bind(this));
        }
      }

      /**
       * Handles the select change event.
       */
      handleSelectChange(event) {
        if (!this.nodeSelectors.flag) {
          return;
        }

        /**
         * Swaps the current flag with the selected country's flag.
         */
        this.nodeSelectors.flag.src = this.nodeSelectors.flag.dataset.src.replace(
          '[country]',
          event.target.value.toLowerCase()
        );
      }
    }
  );
}
